import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { initSentry } from './config/sentry';
import { initGA } from './lib/analytics';
import { initPixel } from './lib/pixel';
import { ErrorBoundary } from './components/error-boundary';
import './index.css';

// Initialize third-party services
console.log(
  `%c ${APP_RELEASE} %c ${import.meta.env.MODE} `,
  'background:#6C5CE7;color:#fff;border-radius:3px 0 0 3px;padding:2px 6px',
  'background:#00B894;color:#fff;border-radius:0 3px 3px 0;padding:2px 6px',
);

initSentry();
initGA();
initPixel();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  </StrictMode>,
);
